import Vue from 'vue'
import RangeSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.mixin({
    components: {
        RangeSlider
    }
});